import React from 'react'
import { Stack, Button, Card, CardContent, Box } from '@mui/material'
import { ViewColumn as ViewColumnIcon } from '@mui/icons-material'
import type { ColumnDef, LineItem } from './types'

interface ItemsListMobileProps {
  items: LineItem[]
  visibleColumns: ColumnDef[]
  renderField: (item: LineItem, index: number, key: string) => React.ReactNode
  columnConfig: Record<string, boolean>
  onOpenColumnConfig: (e: React.MouseEvent<HTMLElement>) => void
  disabled?: boolean
}

const ItemsListMobile: React.FC<ItemsListMobileProps> = ({
  items,
  visibleColumns,
  renderField,
  columnConfig,
  onOpenColumnConfig,
  disabled
}) => {
  return (
    <Stack spacing={2}>
      <Stack direction="row" spacing={1} justifyContent="center">
        <Button
          variant="outlined"
          size="small"
          startIcon={<ViewColumnIcon />}
          onClick={onOpenColumnConfig}
          disabled={!!disabled}
        >
          إعدادات الأعمدة
        </Button>
      </Stack>

      {items.map((item, index) => (
        <Card key={item.id || index} variant="outlined" sx={{ bgcolor: 'grey.50' }}>
          <CardContent sx={{ p: 2 }}>
            <Stack spacing={2}>
              <Box sx={{ 
                display: 'grid', 
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
                gap: 1 
              }}>
                {visibleColumns
                  .filter(col => col.key !== 'actions' && col.key !== 'total')
                  .map((column) => (
                    <Box key={column.key}>
                      {renderField(item, index, column.key)}
                    </Box>
                  ))}
              </Box>

              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                pt: 1,
                borderTop: '1px solid #e0e0e0',
                gap: 2
              }}>
                {columnConfig.total && (
                  <Box sx={{ flex: 1 }}>
                    {renderField(item, index, 'total')}
                  </Box>
                )}
                {columnConfig.actions && (
                  <Box>
                    {renderField(item, index, 'actions')}
                  </Box>
                )}
              </Box>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  )
}

export default ItemsListMobile
